import { Select } from 'antd';
import { omit } from 'lodash';
import useHttpClient from 'hooks/useHttpClient';
import { useQuery } from '@tanstack/react-query';
import { masterDataKeys } from 'features/lost-found-management/keys';
import { appApiMasterIndices } from 'configs/variables';

const { Option } = Select;

export function SpSelectItemModel(props) {
  const { data, isLoading } = useSpSelectItemModel({ params: props?.params });

  return (
    <Select
      {...props}
      loading={isLoading}
      showSearch
      labelInValue
      placeholder="เลือกโมเดล"
      onChange={(value, option) => {
        props?.onChange?.(value, option);
        const selectedModel = data?.find((ss) => ss.id === value.value);

        if (value.value === 'all') {
          const x = {
            label: 'All',
            value: 'all',
          };
          props?.onChange?.(x, option);
        }

        if (selectedModel) {
          const x = {
            ...selectedModel,
            ...omit(value, ['disabled', 'title']),
          };

          props?.onChange?.(x, option);
        }
      }}
    >
      {data?.map((ss, index) => (
        <Option key={index} value={ss.id}>
          {ss.label_en}
        </Option>
      ))}
    </Select>
  );
}

export function useSpSelectItemModel(props) {
  const { get } = useHttpClient();

  const queryRequest = useQuery({
    queryKey: masterDataKeys.selectModel(props?.params).queryKey,
    enabled: !!props?.params?.band_id,
    queryFn: async () =>
      await get({
        url: `${appApiMasterIndices}/lost_and_found/model`,
        params: props?.params || undefined,
      }),
    select: (res) => {
      const { response } = res;
      return response?.data || undefined;
    },
  });

  return queryRequest;
}
